import { buildSvgString, type SvgStringOpts } from '../../svgString';

import { data } from './data';

export const WidgetsSVG = (opts?: SvgStringOpts): string => buildSvgString(data, opts);

export default WidgetsSVG;
